function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "90pt",
    height: "90pt",
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 71.011719 46.621094 C 79.378906 48.148438 76.410156 66.601562 75.328125 72 L 81 72 C 80.640625 66.421875 79.46875 46.890625 83.699219 42.839844 C 88.558594 38.160156 83.96875 21.601562 79.738281 17.820312 C 79.738281 17.820312 58.410156 43.738281 53.460938 44.730469 C 48.511719 45.628906 45.898438 34.921875 42.03125 39.238281 C 37.441406 44.28125 30.421875 52.558594 24.75 56.070312 C 18 60.300781 10.078125 60.75 5.128906 65.609375 C 3.148438 67.5 5.039062 71.910156 5.128906 72.179688 L 49.140625 72 C 51.929688 66.148438 62.550781 45 71.011719 46.621094 Z M 71.011719 46.621094 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoe);
export default __webpack_public_path__ + "static/media/shoe.d1f9de3854efdf3fdd3884088b3c4ef9.svg";
export { ForwardRef as ReactComponent };